import React, { useEffect, useState } from "react";
import { NavLink, useHistory } from "react-router-dom";

import Title from "../../../uiKit/Title/Title";
import { blue600, gray900 } from "../../../uiKit/assets/colors/colors";

const MenuItem = ({
    Icon,
    title,
    url,
    onClick = () => { }
}) => {

    const [selected, setSelected] = useState(false);

    const history = useHistory();

    useEffect(() => {
        if (history.location.pathname.includes(url.split('/')[1])) {
            setSelected(true);
        } else {
            setSelected(false)
        }
    }, [history.location.pathname, url]) 

    return (
        <NavLink
            className={`menuItem ${selected ? 'selected' : ''}`}
            to={url}
            onClick={() => onClick()}
        >
            <div style={{ display: 'flex', alignItems: 'center' }}>
                <div className='menuIcon'>
                    <Icon color={selected ? blue600 : gray900} />
                </div>
                <Title
                    text={title}
                    fontWeight={selected ? 600 : 400}
                    style={{ paddingLeft: '16px' }}
                    color={selected ? blue600 : gray900}
                />
            </div>
        </NavLink>
    )
}

export default MenuItem;